import { useQuery } from '@tanstack/react-query';

import { useSandboxUiContext } from '../hooks';
import { SIMULATION_STATUS_KEY } from '../config';
import { getSimulationStatus } from '../services';

export const useSimulationStatus = () => {
  const sandboxUiContext = useSandboxUiContext();
  const companyToken = sandboxUiContext?.companyToken;

  return useQuery({
    queryKey: [SIMULATION_STATUS_KEY],
    queryFn: async () => {
      if (!companyToken) throw new Error('Company token is missing');

      const simulationStatus = await getSimulationStatus(companyToken);

      if (!simulationStatus) {
        return null;
      }

      return simulationStatus;
    },
    enabled: !!companyToken,
  });
};
